import React from "react";
import { motion } from "framer-motion";
import { APP_SCREENSHOTS } from "@/lib/constants";

const SCREENS = [
  {
    src: APP_SCREENSHOTS.home,
    label: "Home",
    title: "A marketplace, one screen",
    desc: "Education fees, travel and shopping — discover every category from the home feed.",
  },
  {
    src: APP_SCREENSHOTS.educationFeePayment,
    label: "Education Fees",
    title: "Pay verified educators",
    desc: "Search a school, coaching centre or tutor — pay by bank account, mobile number or UPI.",
  },
  {
    src: APP_SCREENSHOTS.verifiedEducators,
    label: "Verified Network",
    title: "KYC-checked sellers",
    desc: "Every educator appearing in your app is bank-account and identity verified.",
  },
];

const PhoneFrame = ({ src, alt }) => (
  <div className="relative w-full aspect-[9/19]">
    <div className="absolute inset-0 rounded-[2.4rem] bg-[#0A0A0A] p-2.5 shadow-[0_25px_60px_-25px_rgba(0,0,0,0.45)]">
      <div className="relative h-full w-full rounded-[2rem] bg-white overflow-hidden">
        <div className="absolute top-2 left-1/2 -translate-x-1/2 h-4 w-20 bg-[#0A0A0A] rounded-full z-10" />
        <img
          src={src}
          alt={alt}
          loading="lazy"
          className="absolute inset-0 h-full w-full object-cover object-top"
        />
      </div>
    </div>
  </div>
);

export const AppGallery = () => {
  return (
    <section
      id="screenshots"
      className="relative py-24 md:py-32 bg-[#FAFAF7]"
    >
      <div className="mx-auto max-w-7xl px-5 sm:px-8">
        <div className="flex items-end justify-between gap-8 flex-wrap mb-14">
          <div className="max-w-2xl">
            <p className="text-[11px] uppercase tracking-[0.22em] font-semibold text-[#F25C2A]">
              · Inside the app
            </p>
            <h2 className="mt-4 font-serif text-4xl sm:text-5xl tracking-tight leading-[1.05] text-[#0A0A0A]">
              Built for high-value <em className="italic text-[#F25C2A] font-normal">fee payments</em>.
            </h2>
          </div>
          <p className="max-w-md text-[#4A4A4A] leading-relaxed">
            A peek at the education-fee flow — discover a verified educator,
            confirm details and complete payment in a few clean steps.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-3 gap-6 lg:gap-10 max-w-5xl mx-auto">
          {SCREENS.map((s, i) => (
            <motion.figure
              key={s.label}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-50px" }}
              transition={{ delay: i * 0.1, duration: 0.55 }}
              className="group"
            >
              <div className="relative">
                <PhoneFrame src={s.src} alt={s.title} />
                <span className="absolute -top-3 left-3 inline-flex items-center gap-1.5 px-3 py-1 rounded-full bg-white border border-[#E5E5E0] text-[10px] font-semibold uppercase tracking-[0.18em] text-[#4A4A4A] shadow-sm">
                  <span className="h-1.5 w-1.5 rounded-full bg-[#F25C2A]" />
                  {s.label}
                </span>
              </div>
              <figcaption className="mt-6">
                <h3 className="font-serif text-lg sm:text-xl leading-snug text-[#0A0A0A]">
                  {s.title}
                </h3>
                <p className="mt-1.5 text-sm text-[#4A4A4A] leading-relaxed">
                  {s.desc}
                </p>
              </figcaption>
            </motion.figure>
          ))}
        </div>
      </div>
    </section>
  );
};
